module.exports = __webpack_public_path__ + "../resources/img/graph_img.a4eddf24.png";